/**
 * Enter/leave animations for Radix parts, keyed off their data-state. Radix keeps a closing part
 * mounted until its `closed` animation ends; the keyframes live in styles/theme.css.
 */

/** Accordion/Collapsible Content: slides open and shut. Padding belongs on a child, or it shows at height 0. */
export const unfold =
  'overflow-hidden data-[state=open]:animate-[unfold_var(--q-motion-normal)_var(--q-ease-in-out)] data-[state=closed]:animate-[fold_var(--q-motion-normal)_var(--q-ease-in-out)_forwards]';

/** Dialog Overlay/Content. */
export const dialogMotion = {
  fade: 'data-[state=open]:animate-[fade_var(--q-motion-normal)_var(--q-ease-out)] data-[state=closed]:animate-[fade-away_var(--q-motion-fast)_var(--q-ease-out)_forwards]',
  slide: 'data-[state=open]:animate-[slide-in_var(--q-motion-normal)_var(--q-ease-out)] data-[state=closed]:animate-[slide-away_var(--q-motion-fast)_var(--q-ease-out)_forwards]',
  pop: 'data-[state=open]:animate-[pop_var(--q-motion-normal)_var(--q-ease-out)] data-[state=closed]:animate-[pop-away_var(--q-motion-fast)_var(--q-ease-out)_forwards]',
};
